import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { CategoriaPermissao } from "../api/dto/categoria-permissao";
import { CategoriaPermissaoAgrupada } from "../api/dto/categoria-permissao-agrupada";

@Injectable({
    providedIn: 'root',
})
export class CategoriaPermissaoService{

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'categorias-permissoes';

    listarTodos(): Observable<CategoriaPermissao[]> {
        return this.http.get<CategoriaPermissao[]>(this.url);
    }

    listarTodosPorEmpresa(): Observable<CategoriaPermissaoAgrupada[]> {
        return this.http.get<CategoriaPermissaoAgrupada[]>(this.url + '/tipo/empresa');
    }

    listarNaoAdicionadasPorUsuarioETipoEmpresa(empresaId?: number, idUsuario?: number): Observable<CategoriaPermissaoAgrupada[]> {
        return this.http.get<CategoriaPermissaoAgrupada[]>(this.url + '/nao-adicionadas/empresa/' + empresaId + '/usuario/' + idUsuario );
    }

    listarNaoAdicionadasPorUsuarioETipoFranquia(franquiaId?: number, idUsuario?: number): Observable<CategoriaPermissaoAgrupada[]> {
        return this.http.get<CategoriaPermissaoAgrupada[]>(this.url + '/nao-adicionadas/administradora/' + franquiaId + '/usuario/' + idUsuario );
    }

    listarAdicionadasPorUsuarioETipoEmpresa(empresaId?: number, idUsuario?: number): Observable<CategoriaPermissaoAgrupada[]> {
        return this.http.get<CategoriaPermissaoAgrupada[]>(this.url + '/adicionadas/empresa/' + empresaId + '/usuario/' + idUsuario );
    }

    listarAdicionadasPorUsuarioETipoFranquia(franquiaId?: number, idUsuario?: number): Observable<CategoriaPermissaoAgrupada[]> {
        return this.http.get<CategoriaPermissaoAgrupada[]>(this.url + '/adicionadas/administradora/' + franquiaId + '/usuario/' + idUsuario );
    }

    listarTodosPorFranquia(): Observable<CategoriaPermissaoAgrupada[]> {
        return this.http.get<CategoriaPermissaoAgrupada[]>(this.url + '/tipo/franquia');
    }
}